import React, { useEffect, useState } from 'react';
import PageBase from 'components/PageBase';
import { getCompteSelLast30, getOnedataUsersLast30, getLivrablesLast30, getOffresLast30 } from 'services/api';
import BarChart from 'components/Chart/BarChart';
import { CircularProgress, Grid, Typography, Card, CardContent } from '@material-ui/core';

const Dashboard = () => {
  const [compteData, setCompteData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [livrablesData, setLivrablesData] = useState([]);
  const [offresData, setOffresData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getCompteSelLast30(),
      getOnedataUsersLast30(),
      getLivrablesLast30(),
      getOffresLast30()
    ])
      .then(([compteRes, usersRes, livrablesRes, offresRes]) => {
        if (compteRes?.code === 200) setCompteData(compteRes.data || []);
        if (usersRes?.code === 200) setUsersData(usersRes.data || []);
        if (livrablesRes?.code === 200) setLivrablesData(livrablesRes.data || []);
        if (offresRes?.code === 200) setOffresData(offresRes.data || []);
      })
      .catch(err => console.error('API error', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PageBase title={"Dashboard"}>
      <div style={{ overflow: 'hidden' }}>
        <Typography variant="h6" style={{marginLeft: 30, marginBottom: 12 }}>CompteSEL creations (last 30 days)</Typography>
        {loading ? (
          <Grid container justify="center"><CircularProgress size={30} /></Grid>
        ) : (
          <Grid container spacing={3} style={{}}>
            <Grid item xs={12} md={4}>
              <Card>
                <CardContent style={{ padding: 16, height: 320 }}>
                  <BarChart
                    title={"CompteSEL creations (last 30 days)"}
                    data={{
                      labels: (compteData || []).map(d => d.date.slice(5)),
                      datasets: [
                        { label: 'Created', data: (compteData || []).map(d => d.count), backgroundColor: '#4285F4' }
                      ]
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardContent style={{ padding: 16, height: 320 }}>
                  <BarChart
                    title={"Onedata users - Total (last 30 days)"}
                    data={{
                      labels: (usersData || []).map(d => d.date.slice(5)),
                      datasets: [ { label: 'Total', data: (usersData || []).map(d => d.total), backgroundColor: '#34A853' } ]
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardContent style={{ padding: 16, height: 320 }}>
                  <BarChart
                    title={"Onedata users - Invited (last 30 days)"}
                    data={{
                      labels: (usersData || []).map(d => d.date.slice(5)),
                      datasets: [ { label: 'Invited', data: (usersData || []).map(d => d.invited), backgroundColor: '#FBBC05' } ]
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardContent style={{ padding: 16, height: 320 }}>
                  <BarChart
                    title={"Onedata users - Confirmed (last 30 days)"}
                    data={{
                      labels: (usersData || []).map(d => d.date.slice(5)),
                      datasets: [ { label: 'Confirmed', data: (usersData || []).map(d => d.confirmed), backgroundColor: '#EA4335' } ]
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardContent style={{ padding: 16, height: 320 }}>
                  <BarChart
                    title={"Livrables created (last 30 days)"}
                    data={{
                      labels: (livrablesData || []).map(d => d.date.slice(5)),
                      datasets: [ { label: 'Created', data: (livrablesData || []).map(d => d.count), backgroundColor: '#8E44AD' } ]
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardContent style={{ padding: 16, height: 320 }}>
                  <BarChart
                    title={"Offres created (last 30 days)"}
                    data={{
                      labels: (offresData || []).map(d => d.date.slice(5)),
                      datasets: [ { label: 'Created', data: (offresData || []).map(d => d.count), backgroundColor: '#2C3E50' } ]
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </div>
    </PageBase>
  );
};

export default Dashboard;
